import styled, { css } from 'styled-components';

export const ScoreKeyHit = styled.div`
  color: #fff;
  min-width: 100px;
  white-space: nowrap;
  background-color: var(--pd-negative-color);
  font-size: 0.85rem;
  border-radius: 60px;
  padding: 0.2rem 1rem;
  position: absolute;
  right: 1rem;
  top: ${(props) => props.$top ?? '-0.85rem'};
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 0.3rem;
  path {
    fill: #fff;
  }
  ${(props) =>
    props.points > 0 &&
    css`
      background-color: var(--pd-positive-color);
    `}
  ${(props) =>
    props.scoreKey === 'neutral' &&
    css`
      background-color: var(--pd-neutral-color);
    `}
    ${(props) =>
    props.positiveScoreObjectiveBut0Points &&
    css`
      background-color: var(--pd-grey-bg-color-dark);
    `}
`;

export const ScoreKeyPadded = styled.div`
  /* height: 0.5rem; */
  width: 100%;
`;
